import { Component, OnInit, ViewChild } from '@angular/core';
import { SalesReportService } from '../sales-report.service';

@Component({
  selector: 'app-sales-report-second-tab',
  templateUrl: './sales-report-second-tab.component.html',
  styleUrls: ['./sales-report-second-tab.component.css']
})
export class SalesReportSecondTabComponent implements OnInit {

  @ViewChild("chart") chart: any;

  OPTION_NUMBER = 1;
  OPTION_DURATION = 2;
  TITLE_NUMBER = "Bookings";
  TITLE_DURATION = "Duration(weeks)";
  tableTitle = this.TITLE_NUMBER;

  constructor(
    public salesReportService: SalesReportService
  ) { }

  ngOnInit(): void {
    this.chart?.refresh();
  }

  setBookingDuration() {
    this.tableTitle = this.TITLE_DURATION;
    this.salesReportService.setCumulativeBookingData(this.salesReportService.result!.cumulativeBookingDurationThisYear, this.salesReportService.result!.cumulativeBookingDurationLastYear);
    this.salesReportService.weekRecordList = this.salesReportService.durationRecordList;
    this.chart.refresh();
  }

  setBookingNumber(){
    this.tableTitle = this.TITLE_NUMBER;
    this.salesReportService.setCumulativeBookingData(this.salesReportService.result!.cumulativeBookingNumberThisYear, this.salesReportService.result!.cumulativeBookingNumberLastYear);
    this.salesReportService.weekRecordList = this.salesReportService.numberRecordList;
    this.chart.refresh();
  }

  changeValue() {
    switch (Number(this.salesReportService.selectedChartOption)) {
      case this.OPTION_NUMBER:
        this.setBookingNumber();
        break;
      case this.OPTION_DURATION:
        this.setBookingDuration();
        break;
    }

  }

}
